import { useEffect, useState } from 'react';
import { taskAPI, TaskAccess } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

/**
 * Whether the signed-in user may use scheduled tasks (admin-granted per user).
 * Cached per user for the page's lifetime so every header render doesn't
 * refetch; call {@link invalidateTaskAccess} after a change that affects it.
 */
let cache: { userId: number; promise: Promise<TaskAccess | null> } | null = null;

export const invalidateTaskAccess = () => {
  cache = null;
};

export const useTaskAccess = (): TaskAccess | null => {
  const { user } = useAuth();
  const [access, setAccess] = useState<TaskAccess | null>(null);

  useEffect(() => {
    if (!user) {
      setAccess(null);
      return;
    }
    if (!cache || cache.userId !== user.userId) {
      cache = {
        userId: user.userId,
        promise: taskAPI.getAccess().then(r => r.data).catch(() => null),
      };
    }
    let alive = true;
    cache.promise.then(a => { if (alive) setAccess(a); });
    return () => { alive = false; };
  }, [user]);

  return access;
};
